import http from './http'
import platform from './platform'

const crud = (base) => ({
  get: (id) => http.get(`${base}/get/${id}`),
  list: (params) => http.get(`${base}/list`, { params }),
  create: (body) => http.post(`${base}/create`, body),
  update: (body) => http.put(`${base}/update`, body),
})

export default {
  platform,
  company: {
    ...crud('/company/v1'),
    update: (body) => http.put('/company/v1/update', body),
    stats: () => http.get('/company/v1/stats'),
  },
  role: { list: () => http.get('/role/v1/list') },
  report: {
    list: () => http.get('/report/v1/list'),
    users: () => http.get('/report/v1/users'),
    usersPdf: () => http.get('/report/v1/users/pdf', { responseType: 'blob' }),
    inventory: () => http.get('/report/v1/inventory'),
    inventoryPdf: () => http.get('/report/v1/inventory/pdf', { responseType: 'blob' }),
  },
  user: {
    ...crud('/user/v1'),
    accounts: () => http.get('/user/v1/accounts'),
    list: (params) => http.get('/user/v1/list', { params }),
    archive: (id) => http.post(`/user/v1/archive/${id}`),
    restore: (id) => http.post(`/user/v1/restore/${id}`),
  },
  job: { ...crud('/job/v1'), delete: (id) => http.delete(`/job/v1/delete/${id}`) },
  jobInventory: {
    ...crud('/jobinventory/v1'),
    detailed: (params) => http.get('/jobinventory/v1/detailed', { params }),
    returnAll: (body) => http.post('/jobinventory/v1/return-all', body),
  },
  customForm: {
    ...crud('/customform/v1'),
    all: (params) => http.get('/customform/v1/all', { params }),
    toggleHidden: (id) => http.post(`/customform/v1/hide/${id}`),
    delete: (id) => http.delete(`/customform/v1/delete/${id}`),
    history: {
      list: (formId) => http.get('/customform/v1/history/list', { params: { form_id: formId } }),
      get: (id) => http.get(`/customform/v1/history/get/${id}`),
    },
  },
  customFormSubmission: {
    ...crud('/customformsubmission/v1'),
    submit: (body) => http.post('/customformsubmission/v1/submit', body),
    list: (params) => http.get('/customformsubmission/v1/list', { params }),
    generatePdfUrl: (id) => `/api/v1/pdfreport/v1/generate/${id}`,
  },
  submissions: {
    list: (params) => http.get('/submissions/v1/list', { params }),
    bulkDownload: (body) => http.post('/pdfreport/v1/bulk-download', body, { responseType: 'blob' }),
  },
  submissionAudit: {
    list: (params) => http.get('/submissionaudit/v1/list', { params }),
    create: (body) => http.post('/submissionaudit/v1/create', body),
    delete: (id) => http.delete(`/submissionaudit/v1/delete/${id}`),
  },
	maintenance: {
		...crud('/maintenance/v1'),
		delete: (id) => http.delete(`/maintenance/v1/delete/${id}`),
	},
	resource: {
		...crud('/resource/v1'),
		list: (params) => http.get('/resource/v1/list', { params }),
		delete: (id) => http.delete(`/resource/v1/delete/${id}`),
	},
  resourceCategory: {
    ...crud('/resourcecategory/v1'),
    delete: (id) => http.delete(`/resourcecategory/v1/delete/${id}`),
  },
  inventory: {
    ...crud('/inventory/v1'),
    list: (params) => http.get('/inventory/v1/list', { params }),
    delete: (id) => http.delete(`/inventory/v1/delete/${id}`),
  },
  materialOrder: {
    ...crud('/materialorder/v1'),
    submit: (body) => http.post('/materialorder/v1/submit', body),
    list: () => http.get('/materialorder/v1/list'),
    bySubmission: (submissionId) => http.get(`/materialorder/v1/by-submission/${submissionId}`),
    getOptions: () => http.get('/materialorder/v1/options'),
    saveOptions: (body) => http.put('/materialorder/v1/options', body),
    generatePdfUrl: (submissionId) => `/api/v1/materialorder/v1/generate/${submissionId}`,
  },
  timesheet: {
    ...crud('/timesheet/v1'),
    submit: (body) => http.post('/timesheet/v1/submit', body),
    list: () => http.get('/timesheet/v1/list'),
    generatePdfUrl: (id) => `/api/v1/timesheet/v1/generate/${id}`,
  },
  hours: {
    get: (id) => http.get(`/hours/v1/get/${id}`),
    list: (params) => http.get('/hours/v1/list', { params }),
    update: (body) => http.put('/hours/v1/update', body),
    payPeriods: () => http.get('/hours/v1/pay-periods'),
  },
  notification: {
    list: (params) => http.get('/notification/v1/list', { params }),
    update: (body) => http.put('/notification/v1/update', body),
    markAllRead: (params) => http.post('/notification/v1/mark-all-read', null, { params }),
  },
  search: {
    query: (q) => http.get('/search/v1/query', { params: { q } }),
  },
  formNotification: {
    list: () => http.get('/formnotification/v1/list'),
    create: (body) => http.post('/formnotification/v1/create', body),
    update: (body) => http.put('/formnotification/v1/update', body),
    delete: (id) => http.delete(`/formnotification/v1/delete/${id}`),
  },
  formDraft: {
    get: (params) => http.get('/formdraft/v1/get', { params }),
    save: (body) => http.put('/formdraft/v1/save', body),
    list: () => http.get('/formdraft/v1/list'),
    delete: (params) => http.delete('/formdraft/v1/delete', { params }),
  },
  billing: {
    status: () => http.get('/billing/v1/status'),
    plans: () => http.get('/billing/v1/plans'),
    upgrade: (body) => http.post('/billing/v1/upgrade', body),
    cancel: () => http.post('/billing/v1/cancel'),
    checkLimit: (type) => http.get('/billing/v1/check-limit', { params: { type } }),
    updateCard: (body) => http.post('/billing/v1/update-card', body),
  },
  config: {
    stripe: () => http.get('/config/v1/stripe'),
  },
  bugReport: {
    submit: (body) => http.post('/bugreport/v1/submit', body),
  },
  errorReport: {
    ingest: (body) => http.post('/errorreport/v1/ingest', body),
  },
  certification: {
    list: (params) => http.get('/certification/v1/list', { params }),
    create: (body) => http.post('/certification/v1/create', body),
    update: (body) => http.put('/certification/v1/update', body),
    delete: (id) => http.delete(`/certification/v1/delete/${id}`),
  },
  upload: (file, prefix = 'uploads', opts = {}) => {
    const form = new FormData()
    form.append('file', file)
    form.append('prefix', prefix)
    const timeout = opts.timeout != null ? opts.timeout : 120000
    return http.post('/upload/v1/create', form, { timeout })
  },
  csvImport: {
    upload: (file, { type, replace, resource_type: resourceType }) => {
      const form = new FormData()
      form.append('file', file)
      form.append('type', type)
      form.append('replace', replace ? 'true' : 'false')
      if (resourceType) form.append('resource_type', resourceType)
      return http.post('/csvimport/v1/upload', form)
    },
  },
}
